// extracted by mini-css-extract-plugin
export var fadeInOut = "_38-3";
export var icon = "_38-4";
export var savedIndicator = "_38-2";
export var savingIndicator = "_38-0";
export var spin = "_38-1";